import { RangeType } from './types'

export interface IBreakpoint extends RangeType {
  stepsSoFar: number
}

export function configureRange(range: RangeType[]) {
  const sorted = range.sort((a, b) => a.value - b.value)
  const breakpoints: IBreakpoint[] = sorted.reduce((result, current, key) => {
    const prev = sorted[key - 1] as IBreakpoint
    const curr = current as IBreakpoint
    if (prev) {
      curr.stepsSoFar = (curr.value - prev.value) / (prev.step as number) + prev.stepsSoFar
    } else {
      curr.stepsSoFar = 0
    }

    if (typeof curr.step === typeof undefined) {
      curr.step = 1
    }
    result.push(curr)
    return result
  }, [] as IBreakpoint[])

  const minStep = breakpoints.at(0)?.stepsSoFar as number
  const maxStep = breakpoints.at(-1)?.stepsSoFar as number
  const minValue = breakpoints.at(0)?.value as number
  const maxValue = breakpoints.at(-1)?.value as number

  // return value within min and max value range
  const ensureValue = (value: number) => {
    if (value > maxValue) {
      return maxValue
    } else if (value < minValue) {
      return minValue
    } else {
      return value
    }
  }

  // calculates value for current steps
  const getValueForStep = (step: number) => {
    // find the nearest breakpoint behind current step
    const nearest = breakpoints.reduce(
      (prev, curr) => (curr.stepsSoFar < step && curr.stepsSoFar > prev!.stepsSoFar ? curr : prev),
      breakpoints.at(0)
    ) as IBreakpoint
    // determine value past nearest breakpoint value
    const additionalValue = (step - nearest.stepsSoFar) * (nearest.step as number)
    return nearest.value + additionalValue
  }

  // calculates number of steps for current value
  const getStepForValue = (value: number) => {
    // find the nearest breakpoint behind current value
    const nearest = breakpoints.reduce(
      (prev, curr) => (curr.value < value && curr.value > prev!.value ? curr : prev),
      breakpoints.at(0)
    ) as IBreakpoint
    // determine number of steps past nearest breakpoint steps so far
    const additionalSteps = (value - nearest.value) / (nearest.step as number)
    return nearest.stepsSoFar + additionalSteps
  }

  return {
    minStep,
    maxStep,
    minValue,
    maxValue,
    ensureValue,
    getValueForStep,
    getStepForValue
  }
}
